"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toScanAccountEventRaw = exports.fromScanAccountEventRaw = exports.getAccountBridge = exports.getCurrencyBridge = exports.setBridgeProxy = void 0;
const account_1 = require("../account");
const impl = __importStar(require("./impl"));
let proxy;
const setBridgeProxy = (p) => {
    if (p && p.getAccountBridge === exports.getAccountBridge) {
        throw new Error("setBridgeProxy can't be called with same bridge functions!");
    }
    proxy = p;
};
exports.setBridgeProxy = setBridgeProxy;
const getCurrencyBridge = (currency) => (proxy || impl).getCurrencyBridge(currency);
exports.getCurrencyBridge = getCurrencyBridge;
const getAccountBridge = (account, parentAccount) => (proxy || impl).getAccountBridge(account, parentAccount);
exports.getAccountBridge = getAccountBridge;
function fromScanAccountEventRaw(raw) {
    switch (raw.type) {
        case "discovered":
            return {
                type: raw.type,
                account: (0, account_1.fromAccountRaw)(raw.account),
            };
        default:
            throw new Error("unsupported ScanAccountEvent " + raw.type);
    }
}
exports.fromScanAccountEventRaw = fromScanAccountEventRaw;
function toScanAccountEventRaw(e) {
    switch (e.type) {
        case "discovered":
            return {
                type: e.type,
                account: (0, account_1.toAccountRaw)(e.account),
            };
        default:
            throw new Error("unsupported ScanAccountEvent " + e.type);
    }
}
exports.toScanAccountEventRaw = toScanAccountEventRaw;
//# sourceMappingURL=index.js.map